import React from 'react';
import { Typography } from '@mui/material';
import { Backup } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../UIKit/Button';
// Панель управления резервными копиями базы данных
const DatabaseBackupPanel = () => {
  const { t } = useTranslation(['admin']);

  return (
    <div>
      {/* Заголовок */}
      <Typography variant="h6" gutterBottom>
        {t('admin:databaseBackup.title')}
      </Typography>
      {/* Описание */}
      <Typography variant="body1" paragraph>
        {t('admin:databaseBackup.description')}
      </Typography>
      {/* Кнопка перехода */}
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/admin/database-backup"
        startIcon={<Backup />}
      >
        {t('admin:databaseBackup.button')}
      </Button>
    </div>
  );
};

export default DatabaseBackupPanel;
